import styles from './PackGalleryCaption.module.scss'

/**
 * Gallery caption row (plan edit 06). Placed at the top of detailHero__right,
 * before the pack.rows.map. Reads the same on all breakpoints — there is no
 * desktop-only or mobile-only variant.
 *
 * Placement deviation logged in thinking/threads/narcis_redesign.md:
 * the handoff imagined a separate gallery section; the real page has no such
 * split — the gallery IS detailHero__right. Caption is inserted at the top of
 * detailHero__right on all breakpoints.
 */
export function PackGalleryCaption() {
    return (
        <p className={styles.caption} role="note">
            all 9 photos in this pack ↓
        </p>
    )
}
